import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import App from './App'
import TamponBaski from './pages/TamponBaski'
import Serigrafi from './pages/Serigrafi'
import MontajTrim from './pages/MontajTrim'
import Kurumsal from './pages/Kurumsal'
// English pages
import AppEN from './pages/en/AppEN'
import PadPrinting from './pages/en/PadPrinting'
import ScreenPrinting from './pages/en/ScreenPrinting'
import AssemblyTrim from './pages/en/AssemblyTrim'
import Corporate from './pages/en/Corporate'
// German pages
import AppDE from './pages/de/AppDE'
import Tampondruck from './pages/de/Tampondruck'
import Siebdruck from './pages/de/Siebdruck'
import MontageTrim from './pages/de/MontageTrim'
import Unternehmen from './pages/de/Unternehmen'
// Blog Pages
import BlogIndex from './pages/blog/BlogIndex'
import BlogPost from './pages/blog/BlogPost'
import NotFound from './pages/NotFound'
import HreflangManager from './components/HreflangManager'
import InteractionTracker from './components/InteractionTracker'
import { trackPageView } from './lib/analytics'
import CanonicalManager from './components/CanonicalManager'
import ConsentLayer from './components/ConsentLayer'
import MobileRfqBar from './components/MobileRfqBar'
import { langFromPath } from './lib/routes'

/* The page view waits for the page's own <title> (Helmet and useServiceSeo
   set it after this effect runs). */
const PAGE_VIEW_DELAY_MS = 300

// Google Analytics page view tracker (consent-gated in src/lib/analytics.js;
// gtag's config sends none, so each route change counts once).
function AnalyticsTracker() {
    const location = useLocation()

    const page = location.pathname + location.search

    // One page view per page: a hash change (a #contact CTA) is not one.
    useEffect(() => {
        const timer = window.setTimeout(trackPageView, PAGE_VIEW_DELAY_MS)
        return () => window.clearTimeout(timer)
    }, [page])

    useEffect(() => {
        // Scroll restoration on route change
        // Only scroll to top if there's no hash (anchor link)
        if (!location.hash) {
            window.scrollTo(0, 0)
        }
    }, [location])

    return null
}

// <html lang> follows the route (tr / en / de). Screen readers pick the right
// voice, the prerendered EN/DE pages declare their language, and uppercase
// legends use the right casing rules (no Turkish dotted İ on EN/DE pages).
function DocumentLang() {
    const { pathname } = useLocation()

    useEffect(() => {
        document.documentElement.lang = langFromPath(pathname)
    }, [pathname])

    return null
}

function Router() {
    return (
        <BrowserRouter>
            <AnalyticsTracker />
            <InteractionTracker />
            <DocumentLang />
            <HreflangManager />
            <CanonicalManager />
            <Routes>
                {/* Turkish pages */}
                <Route path="/" element={<App />} />
                <Route path="/tampon-baski" element={<TamponBaski />} />
                <Route path="/serigrafi" element={<Serigrafi />} />
                <Route path="/montaj-trim" element={<MontajTrim />} />
                <Route path="/kurumsal" element={<Kurumsal />} />
                <Route path="/blog" element={<BlogIndex lang="tr" />} />
                <Route path="/blog/:slug" element={<BlogPost lang="tr" />} />
                {/* English pages */}
                <Route path="/en" element={<AppEN />} />
                <Route path="/en/pad-printing" element={<PadPrinting />} />
                <Route path="/en/screen-printing" element={<ScreenPrinting />} />
                <Route path="/en/assembly-trim" element={<AssemblyTrim />} />
                <Route path="/en/corporate" element={<Corporate />} />
                <Route path="/en/blog" element={<BlogIndex lang="en" />} />
                <Route path="/en/blog/:slug" element={<BlogPost lang="en" />} />
                {/* German pages */}
                <Route path="/de" element={<AppDE />} />
                <Route path="/de/tampondruck" element={<Tampondruck />} />
                <Route path="/de/siebdruck" element={<Siebdruck />} />
                <Route path="/de/montage-trim" element={<MontageTrim />} />
                <Route path="/de/unternehmen" element={<Unternehmen />} />
                <Route path="/de/blog" element={<BlogIndex lang="de" />} />
                <Route path="/de/blog/:slug" element={<BlogPost lang="de" />} />

                {/* Anything else: a noindex 404 in the path's language */}
                <Route path="*" element={<NotFound />} />
            </Routes>
            <MobileRfqBar />
            <ConsentLayer />
        </BrowserRouter>
    )
}

export default Router

